<template>
  <div class="flex flex-col items-center">
    <star-rating :count="0" :average="0" :showCount="false" class="mx-auto" />
    <note-box
      v-if="profileBelongsToViewer"
      class="mt-8"
      header="Request reviews"
      body="Request a review from any parent you've worked with to add it to your profile"
    />
    <p v-else class="text-body mt-8">Be the first to leave a review</p>
    <poppins-button :value="buttonValue" variant="outlined" size="medium" class="w-full mt-16" :href="buttonHref" />
  </div>
</template>

<script lang="ts">
import StarRating from '@/components/star_rating/StarRating.vue';
import NoteBox from '@/components/note_box/NoteBox.vue';
import PoppinsButton from '@/components/button/Button.vue';

export default {
  name: 'ProfileReviewsEmptyState',
  components: {
    StarRating,
    NoteBox,
    PoppinsButton,
  },
  props: {
    profileAccountData: {
      type: Object,
      default: () => ({}),
    },
    profileBelongsToViewer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonValue(): string {
      return this.profileBelongsToViewer ? 'Request reviews' : 'Leave a review';
    },
    buttonHref(): string {
      const encodedUri = encodeURIComponent(window.location.pathname);
      return this.profileBelongsToViewer
        ? `/provider/reviews/request`
        : `/ratings/sitters/${this.profileAccountData.id}/new?return-path=${encodedUri}`;
    },
  },
};
</script>
